import { Outlet } from "react-router-dom";
import { Backdrop, Box, Card, CircularProgress } from "@mui/material";

export const PublicLayout = () => {
  return (
    <div
      id="external"
      className="h-full w-full p-2 custom-background flex justify-center items-center"
    >
      <Box className="xl:w-[50%] lg:w-[65%] md:w-[80%] sm:w-[95%] w-[100%] my-auto">
        <Card
          className="border-0"
          style={{ backgroundColor: "rgba(255, 255, 255, 0.5)" }}
          sx={{ position: "relative" }}
        >
          <Outlet></Outlet>
          <Backdrop
            className="bg-black bg-opacity-30"
            sx={{ position: "absolute", zIndex: 1 }}
          >
            <CircularProgress className="text-primary" />
          </Backdrop>
        </Card>
      </Box>
    </div>
  );
};
